import React, { memo } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { formatAddress } from "../../../../../../utils/propertyData";
function PropertyInfo(props) {
  let { classes } = props;
  const listDetail = useSelector((state) => state.allCmas.listingDetail);

  return (
    <Box id="property-info" className={classes.propertyInfoArea}>
      <Typography className={classes.propertyInfoHeading}>
        Property Information for {formatAddress(listDetail?.data)}
      </Typography>
      <Box
        className={classes.propertyInfoDetailBox}
        sx={{ mt: "20px  !important" }}
      >
        <Typography
          className={classes.propertyInfoDetailBoxHeading}
          variant="subtitle2"
          display="block"
          gutterBottom
        >
          Summary
        </Typography>
        <Box className={classes.propertyInfoDetailBoxInner}>
          <Grid container spacing={2}>
            <Grid item sm={12} md={6}>
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Location and General Information
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                {listDetail?.data?.CommunityFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Community Features:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.CommunityFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Directions ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Directions:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.Directions}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.lakeName ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Lake Name:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        None
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.View?.length ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      View:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.View?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Coordinates ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Coordinates:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {typeof listDetail?.data?.Coordinates === "string"
                          ? listDetail?.data?.Coordinates
                          : listDetail?.data?.Coordinates?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
              </ul>
            </Grid>
            <Grid item sm={12} md={6}>
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                School Information
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                {listDetail?.data?.ElementarySchool ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Elementary School:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.ElementarySchool}
                      </span>
                    </Typography>
                  </li>
                ) : null}

                {listDetail?.data?.MiddleOrJuniorSchool ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Middle School:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.MiddleOrJuniorSchool}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.HighSchool ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      High School:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.HighSchool}
                      </span>
                    </Typography>
                  </li>
                ) : null}
              </ul>
            </Grid>

            <Grid item sm={12} md={6}>
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Taxes and HOA Information
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                {listDetail?.data?.ParcelNumber ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Parcel Number:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.ParcelNumber}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.TaxYear ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Tax Year:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.TaxYear}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.AssociationFeeIncludes ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Association Fee Includes:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.AssociationFeeIncludes?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.TaxLegalDescription ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Tax Legal Description:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {listDetail?.data?.TaxLegalDescription}
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.TaxLot ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Tax Lot:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {listDetail?.data?.TaxLot}
                    </Typography>
                  </li>
                ) : null}
              </ul>
            </Grid>
            <Grid item sm={12} md={6}>
              {listDetail?.data?.FMLS_VirtualTourURLUnbranded2 ? (
                <Typography
                  className={classes.propertyInfoDetailBoxInnerHeading}
                >
                  Virtual Tour
                </Typography>
              ) : null}
              <ul>
                {listDetail?.data?.FMLS_VirtualTourURLUnbranded2 ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Virtual Tour Link PP:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                      component={"a"}
                      href={listDetail?.data?.FMLS_VirtualTourURLUnbranded2}
                      sx={{ color: "#7444A0 !important" }}
                    >
                      {listDetail?.data?.FMLS_VirtualTourURLUnbranded2}
                    </Typography>
                  </li>
                ) : null}
              </ul>
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Parking
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                <li>
                  <Typography className={classes.propertyInfoDetailBoxInnerDes}>
                    Open Parking:
                  </Typography>
                  <Typography
                    className={classes.propertyInfoDetailBoxInnerDes}
                    variant="subtitle2"
                    gutterBottom
                  >
                    {listDetail?.data?.OpenParkingYN ? "Yes" : "No"}
                  </Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        className={classes.propertyInfoDetailBox}
        sx={{ borderBottom: "none !important" }}
      >
        <Typography
          className={classes.propertyInfoDetailBoxHeading}
          variant="subtitle2"
          display="block"
          gutterBottom
        >
          Interior and Exterior Features
        </Typography>
        <Box className={classes.propertyInfoDetailBoxInner}>
          <Grid container spacing={4}>
            <Grid item sm={12} md={6}>
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Interior Features
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                {listDetail?.data?.Cooling ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Cooling:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.Cooling?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Heating ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Heating:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.Heating?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Appliances ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Appliances:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.Appliances?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Basement ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Basement:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.Basement?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.FireplaceFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Fireplace Features:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.FireplaceFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Flooring ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Flooring:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.Flooring?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.InteriorFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Interior Features:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.InteriorFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Levels ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Levels/Stories:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.Levels?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.OtherEquipment ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Other Equipment:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.OtherEquipment?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.WindowFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Window Features:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.WindowFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.RoomKitchenFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Kitchen Features:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.RoomKitchenFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.RoomMasterBathroomFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Master Bathroom Features:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.RoomMasterBathroomFeatures?.join(
                          ", "
                        )}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.FoundationDetails ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Foundation:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.FoundationDetails?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.MainLevelBedrooms ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Main Bedrooms:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {listDetail?.data?.MainLevelBedrooms}
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.BathroomsHalf ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Total Half Baths:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {listDetail?.data?.BathroomsHalf}
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.BathroomsTotalInteger ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Bathrooms Total Integer:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {listDetail?.data?.BathroomsTotalInteger}
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.MainLevelBathrooms ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Main Full Baths:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {listDetail?.data?.MainLevelBathrooms}
                    </Typography>
                  </li>
                ) : null}

                {/* <li>
                  <Typography className={classes.propertyInfoDetailBoxInnerDes}>
                    Additional Rooms:
                  </Typography>
                  <Typography
                 className={classes.propertyInfoDetailBoxInnerSubHeading}
                    variant="subtitle2"
                    gutterBottom
                  >
                    --
                  </Typography>
                </li> */}
                {listDetail?.data?.BathroomsTotalDecimal ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Bathrooms Total Decimal:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {listDetail?.data?.BathroomsTotalDecimal}
                    </Typography>
                  </li>
                ) : null}
              </ul>
            </Grid>
            <Grid item sm={12} md={6}>
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Exterior Features
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                {listDetail?.data?.AccessibilityFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Accessibility Features:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.AccessibilityFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.ConstructionMaterials ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Construction Materials:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.ConstructionMaterials?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Fencing ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Fencing:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.Fencing?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.HorseAmenities ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Horse Amenities:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.HorseAmenities?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.PatioAndPorchFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Patio And Porch Features:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.PatioAndPorchFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.PoolFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Pool Features:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.PoolFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.RoadSurfaceType ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Road Surface Type:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.RoadSurfaceType?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Roof ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Roof Type:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.Roof?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.SecurityFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Security Features:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.SecurityFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.SpaFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Spa Features:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.SpaFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.LaundryFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Laundry Features:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.LaundryFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}

                <li>
                  <Typography className={classes.propertyInfoDetailBoxInnerDes}>
                    Pool Private:
                  </Typography>
                  <Typography
                    className={classes.propertyInfoDetailBoxInnerDes}
                    variant="subtitle2"
                    gutterBottom
                  >
                    {listDetail?.data?.PoolPrivateYN ? "Yes" : "No"}
                  </Typography>
                </li>
                {listDetail?.data?.RoadFrontageType ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Road Frontage Type:
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.RoadFrontageType?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.OtherStructures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Other Structures:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.OtherStructures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
              </ul>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        className={classes.propertyInfoDetailBox}
        sx={{ borderBottom: "none  !important" }}
      >
        <Typography
          className={classes.propertyInfoDetailBoxHeading}
          variant="subtitle2"
          display="block"
          gutterBottom
        >
          Property
        </Typography>
        <Box className={classes.propertyInfoDetailBoxInner}>
          <Grid container spacing={4}>
            <Grid item sm={12} md={6}>
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Utilities
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                {listDetail?.data?.Sewer ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Sewer:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.Sewer?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Utilities ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Utilities:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.Utilities?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.WaterSource ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Water Source:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.WaterSource?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.Electric ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Electric:{" "}
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.Electric?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
              </ul>
              <br />
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Property and Assessments
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                <li>
                  <Typography className={classes.propertyInfoDetailBoxInnerDes}>
                    Home Warranty:
                  </Typography>
                  <Typography
                    className={classes.propertyInfoDetailBoxInnerDes}
                    variant="subtitle2"
                    gutterBottom
                  >
                    {listDetail?.data?.View?.HomeWarrantyYN ? "Yes" : "No"}
                  </Typography>
                </li>
                {listDetail?.data?.PropertyCondition ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Property Condition:
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.PropertyCondition?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
              </ul>
            </Grid>
            <Grid item sm={12} md={6}>
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Green Features
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                {listDetail?.data?.GreenEnergyEfficient ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Green Energy Efficient:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.GreenEnergyEfficient?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.GreenEnergyGeneration ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Green Energy Generation:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.GreenEnergyGeneration?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
              </ul>
              <br />
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Lot Information
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                {listDetail?.data?.AboveGradeFinishedArea ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Above Grade Finished Area:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {listDetail?.data?.AboveGradeFinishedArea}
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.CommonWalls ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Common Walls:
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.CommonWalls?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.LotFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Lot Features:
                      <span
                        className={classes.propertyInfoDetailBoxInnerSubHeading}
                      >
                        {listDetail?.data?.LotFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
                {listDetail?.data?.WaterfrontFeatures ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Waterfront Footage:{" "}
                      <span className={classes.propertyInfoDetailBoxInnerDes}>
                        {listDetail?.data?.WaterfrontFeatures?.join(", ")}
                      </span>
                    </Typography>
                  </li>
                ) : null}
              </ul>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {listDetail?.data?.UnitNumber || listDetail?.data?.BuildingAreaUnits ? (
        <Box
          className={classes.propertyInfoDetailBox}
          sx={{ borderBottom: "none  !important" }}
        >
          <Typography
            className={classes.propertyInfoDetailBoxHeading}
            variant="subtitle2"
            display="block"
            gutterBottom
          >
            Multi Family
          </Typography>
          <Box className={classes.propertyInfoDetailBoxInner}>
            <Grid container spacing={4}>
              {listDetail?.data?.UnitNumber ||
              listDetail?.data?.BuildingAreaUnits ? (
                <Grid item sm={12} md={6}>
                  <Typography
                    className={classes.propertyInfoDetailBoxInnerHeading}
                    variant="subtitle2"
                    gutterBottom
                  >
                    Multi-Family Information
                  </Typography>
                  <ul style={{ paddingLeft: "16px" }}>
                    {listDetail?.data?.UnitNumber ? (
                      <li>
                        <Typography
                          className={classes.propertyInfoDetailBoxInnerDes}
                        >
                          # Of Units In Community:{" "}
                        </Typography>
                        <Typography
                          className={classes.propertyInfoDetailBoxInnerDes}
                          variant="subtitle2"
                          gutterBottom
                        >
                          {listDetail?.data?.UnitNumber}
                        </Typography>
                      </li>
                    ) : null}
                    {listDetail?.data?.BuildingAreaUnits ? (
                      <li>
                        <Typography
                          className={classes.propertyInfoDetailBoxInnerDes}
                        >
                          Number of Units To Be Built:
                        </Typography>
                        <Typography
                          className={classes.propertyInfoDetailBoxInnerDes}
                          variant="subtitle2"
                          gutterBottom
                        >
                          {listDetail?.data?.BuildingAreaUnits}
                        </Typography>
                      </li>
                    ) : null}
                  </ul>
                </Grid>
              ) : null}
            </Grid>
          </Box>
        </Box>
      ) : null}

      <Box className={classes.propertyInfoDetailBox}>
        <Typography
          className={classes.propertyInfoDetailBoxHeading}
          variant="subtitle2"
          display="block"
          gutterBottom
        >
          Rental
        </Typography>
        <Box className={classes.propertyInfoDetailBoxInner}>
          <Grid container spacing={4}>
            <Grid item sm={12} md={6}>
              <Typography className={classes.propertyInfoDetailBoxInnerHeading}>
                Rent Information
              </Typography>
              <ul style={{ paddingLeft: "16px" }}>
                <li>
                  <Typography className={classes.propertyInfoDetailBoxInnerDes}>
                    Land Lease:{" "}
                  </Typography>
                  <Typography
                    className={classes.propertyInfoDetailBoxInnerDes}
                    variant="subtitle2"
                    gutterBottom
                  >
                    {listDetail?.data?.LandLeaseYN ? "Yes" : "No"}
                  </Typography>
                </li>
                {listDetail?.data?.OccupantType ? (
                  <li>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                    >
                      Occupant Types:
                    </Typography>
                    <Typography
                      className={classes.propertyInfoDetailBoxInnerDes}
                      variant="subtitle2"
                      gutterBottom
                    >
                      {listDetail?.data?.OccupantType}
                    </Typography>
                  </li>
                ) : null}
              </ul>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
export default memo(PropertyInfo);
